import { render, staticRenderFns } from "./LibraryCertificatesModal.vue?vue&type=template&id=6f86eca0&scoped=true"
import script from "./LibraryCertificatesModal.vue?vue&type=script&lang=ts"
export * from "./LibraryCertificatesModal.vue?vue&type=script&lang=ts"
import style0 from "./LibraryCertificatesModal.vue?vue&type=style&index=0&id=6f86eca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f86eca0",
  null
  
)

export default component.exports